<template>
  <div class="how-to-start">
    <Heading size="h5">
      {{ title }}
    </Heading>
    <div class="how-to-start__player">
      <iframe
        :src="playerUrl"
        class="how-to-start__player-iframe"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/common/Heading/Heading'

export default {
  components: {
    Heading
  },

  props: {
    title: {
      type: String,
      required: true
    },
    videoUrl: {
      type: String,
      required: true
    }
  },

  computed: {
    playerUrl () {
      return `${this.videoUrl}?h=4ef6c9fed3&color=F87900&title=0&byline=0&portrait=0`
    }
  }
}
</script>

<style lang="scss" scoped>
.how-to-start {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $gap * 5 $gap;
  gap: $gap * 2;

  &__player {
    position: relative;
    overflow: hidden;
    max-width: 1120px;
    width: 100%;
    aspect-ratio: 16 / 9;
    margin: 0 auto;
    &-iframe {
      position: absolute;
      border-radius: $gap;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
